import type { ITrafficSituation } from '../../../../../models/traffic-situation.model';
import { t } from '../../../../../services/texts.service';
import Fact from '../../../../Shared/Fact';
import { IconMotif } from '../../../../Shared/Icon/icon-motif.enum';
import { AffectedPeriodsFactHelper } from './affected-periods-fact.helper';

export default function AffectedPeriodsFact({ trafficSituation, className = '' }: { trafficSituation: ITrafficSituation; className?: string }): React.ReactNode | null {
  const formattedPeriods = AffectedPeriodsFactHelper.getFormattedPeriods(trafficSituation.activeTimes);
  if (formattedPeriods.length === 0) return null;

  const heading = t('Påverkade tider', 'Affected periods');

  return (
    <Fact className={`align-items-start ${className}`.trim()} iconMotif={IconMotif.Clock} altText="">
      <div className="d-flex flex-column">
        <span className="fw-bold">{heading}:</span>
        {formattedPeriods.map((period, index) => (
          <span key={`${period}-${index}`}>{period}</span>
        ))}
      </div>
    </Fact>
  );
}
